import { ArrowRightIcon } from 'lucide-react'
import { useMemo } from 'react'

import { getFilteredProducts } from 'components/members/components/ExploreMarketplaceCard/ExploreMarketplaceCard'
import { membersMarketplace } from 'rails_routes'
import { TextLink } from 'slab'
import { useGetMarketplaceProducts } from 'utils/web_api'
import { type MarketplaceProduct } from 'utils/web_api.schemas'

import MarketplaceProductCard from '../MarketplaceProductCard/MarketplaceProductCard'

interface MarketplaceProductSectionProps {
  filterToCategories?: string[];
}

const pickTwoRandomProducts = (
  products: MarketplaceProduct[]
): MarketplaceProduct[] => {
  if (!products || products.length === 0) return []
  if (products.length === 1) return products
  return products.sort(() => Math.random() - 0.5).slice(0, 2)
}

const MarketplaceProductSection: React.FC<MarketplaceProductSectionProps> = ({
  filterToCategories,
}) => {
  const { data, isLoading } = useGetMarketplaceProducts(undefined, {
    query: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  })

  const products = useMemo(() => {
    const filteredProducts = getFilteredProducts(
      data?.data || [],
      filterToCategories
    )
    return pickTwoRandomProducts(filteredProducts)
  }, [data, filterToCategories])

  if (!isLoading && products.length === 0) return null

  return (
    <div className='w-full h-full p-4 rounded-lg border border-gray-200 bg-gradient-to-b from-thatch-200 via-thatch-100 to-transparent shadow-sm'>
      <div className='flex flex-row justify-between mb-3'>
        <div className='body-bold text-gray-800'>Marketplace</div>
        <TextLink
          href={membersMarketplace.index()}
          target='_blank'
          rightIcon={ArrowRightIcon}
          color='purple'
        >
          View all
        </TextLink>
      </div>
      <p className='body-sm text-gray-500 mb-3'>
        Shop high-impact health products & services at exclusive member prices
        using your Thatch balance
      </p>
      <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
        {!!products && products.length > 0
          ? (
              products.map((product, index) => (
                <MarketplaceProductCard
                  key={product?.id || index}
                  product={product}
                  isLoading={isLoading}
                />
              ))
            )
          : (
            <>
              <MarketplaceProductCard isLoading={isLoading} />
              <MarketplaceProductCard isLoading={isLoading} />
            </>
            )}
      </div>
    </div>
  )
}

export default MarketplaceProductSection
